import { Inject, Injectable } from '@angular/core';
import {
  ProductModel,
  StorePageStore,
  STORE_SERVICE,
  IStoreService,
} from '@boxx/store-core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  catchError,
  mergeMap,
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';
import * as fromProductsActions from './store-products.actions';

@Injectable()
export class StoreProductsEffects {
  loadProducts$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromProductsActions.loadProductsBeginAction),
      switchMap(() =>
        this.service.loadProducts().pipe(
          mergeMap((payload) => [
            fromProductsActions.loadProductsSuccessAction({ payload }),
            fromProductsActions.clearProductsSuccessErrorDataAction(),
          ]),
          catchError((errors) => {
            console.error('StoreEffects.loadProducts$ ERROR', errors);
            return of([
              fromProductsActions.loadProductsFailAction({ errors }),
              fromProductsActions.clearProductsSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  loadProductById$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromProductsActions.loadProductByIdBeginAction),
      switchMap((action: any) =>
        this.service.loadProductById(action.id).pipe(
          mergeMap((payload) => [
            fromProductsActions.loadProductByIdSuccessAction({ payload }),
            fromProductsActions.clearProductsSuccessErrorDataAction(),
          ]),
          catchError((errors) => {
            console.error('StoreEffects.loadProductById$ ERROR', errors);
            return of([
              fromProductsActions.loadProductByIdFailAction({ errors }),
              fromProductsActions.clearProductsSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  createProduct$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromProductsActions.createProductBeginAction),
      withLatestFrom(this.storePageStore.productsStore.data$),
      switchMap(([action, productsData]: [any, ProductModel[]]) =>
        this.service.createProduct(action.payload).pipe(
          mergeMap((data) => {
            //const payload = productsData;//[data, ...productsData];
            const payload  = {
              products: productsData,
              newProduct: data
            };

            return [
              fromProductsActions.createProductSuccessAction({ payload }),
              fromProductsActions.clearProductsSuccessErrorDataAction(),
            ];
          }),
          catchError((errors) => {
            console.error('StoreEffects.CreateProducts$ ERROR', errors);
            return of([
              fromProductsActions.createProductFailAction({ errors }),
              fromProductsActions.clearProductsSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  updateProduct$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromProductsActions.updateProductBeginAction),
      withLatestFrom(this.storePageStore.productsStore.data$),
      switchMap(([action, productsData]: [any, ProductModel[]]) =>
        this.service.updateProduct(action.payload).pipe(
          mergeMap((data) => {
            const payload = action.payload;

            return [
              fromProductsActions.updateProductSuccessAction({ payload }),
              fromProductsActions.clearProductsSuccessErrorDataAction(),
            ];
          }),
          catchError((errors) => {
            console.error('StoreEffects.UpdateProducts$ ERROR', errors);
            return of([
              fromProductsActions.updateProductFailAction({ errors }),
              fromProductsActions.clearProductsSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  deleteProduct$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromProductsActions.deleteProductBeginAction),
      withLatestFrom(this.storePageStore.productsStore.data$),
      switchMap(([action, productsData]: [any, ProductModel[]]) =>
        this.service.deleteProduct(action.id).pipe(
          mergeMap(() => {
            const payload = productsData.filter((p) => p.id !== action.id);
            return [
              fromProductsActions.deleteProductSuccessAction({ payload }),
              fromProductsActions.clearProductsSuccessErrorDataAction(),
            ];
          }),
          catchError((errors) => {
            console.error('StoreEffects.deleteProduct$ ERROR', errors);
            return of([
              fromProductsActions.deleteProductFailAction({ errors }),
              fromProductsActions.clearProductsSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

//   getSingleProduct$ = createEffect(() =>
//   this.actions.pipe(
//     ofType(fromProductsActions.loadSingleProductBeginAction),
//     withLatestFrom(this.storePageStore.productsStore.data$),
//     switchMap(([action, productsData]: [any, ProductModel[]]) =>
//       this.service.getSingleProduct(action.id).pipe(
//         mergeMap((data) => {
//           const payload = data
//           // [data, ...productsData];
//           return [
//             fromProductsActions.loadSingleProductSuccessAction({ payload }),
//             fromProductsActions.clearProductsSuccessErrorDataAction(),
//           ];
//         }),
//         catchError((errors) => {
//           console.error('StoreEffects.getSingleProduct$ ERROR', errors);
//           return of([
//             fromProductsActions.loadSingleProductFailAction({ errors }),
//             fromProductsActions.clearProductsSuccessErrorDataAction(),
//           ]).pipe(switchMap((d) => d));
//         })
//       )
//     )
//   )
// );

getSingleProduct$ = createEffect(() =>
  this.actions.pipe(
    ofType(fromProductsActions.loadSingleProductBeginAction),
    withLatestFrom(this.storePageStore.productsStore.data$),
    switchMap(([action, productsData]: [any, ProductModel[]]) =>
      this.service.getSingleProduct(action.id).pipe(
        mergeMap((data) => {
          const payload = [data, ...productsData];
          return [
            fromProductsActions.loadSingleProductSuccessAction({ payload }),
            fromProductsActions.clearProductsSuccessErrorDataAction(),
          ];
        }),
        catchError((errors) => {
          console.error('StoreEffects.getSingleProduct$ ERROR', errors);
          return of([
            fromProductsActions.loadSingleProductFailAction({ errors }),
            fromProductsActions.clearProductsSuccessErrorDataAction(),
          ]).pipe(switchMap((d) => d));
        })
      )
    )
  )
);

getUpdatedProduct$ = createEffect(() =>
  this.actions.pipe(
    ofType(fromProductsActions.loadUpdatedProductBeginAction),
    withLatestFrom(this.storePageStore.productsStore.data$),
    switchMap(([action]: [any, any]) =>
      this.service.getSingleProduct(action.id).pipe(
        mergeMap((data) => {
          const payload = data;
          return [
            fromProductsActions.loadUpdatedProductSuccessAction({ payload }),
            fromProductsActions.clearProductsSuccessErrorDataAction(),
          ];
        }),
        catchError((errors) => {
          console.error('StoreEffects.getSingleProduct$ ERROR', errors);
          return of([
            fromProductsActions.loadUpdatedProductFailAction({ errors }),
            fromProductsActions.clearProductsSuccessErrorDataAction(),
          ]).pipe(switchMap((d) => d));
        })
      )
    )
  )
);

deleteImageProduct$ = createEffect(() =>
this.actions.pipe(
  ofType(fromProductsActions.deleteImageProductBeginAction),
  withLatestFrom(this.storePageStore.productsStore.data$),
  switchMap(([action, productsData]: [any, any]) =>
    this.service.deleteImageProduct(action.payload).pipe(
      mergeMap((res) =>
      {
        const payload = action.payload;

        return [
          fromProductsActions.deleteImageProductSuccessAction({payload}),
          fromProductsActions.clearProductsSuccessErrorDataAction(),
        ];
      }
      ),
      catchError((errors) => {
        console.error('StoreEffects.deleteImageCategory$ ERROR', errors);
        return of([
          fromProductsActions.deleteImageProductFailAction({ errors }),
          fromProductsActions.clearProductsSuccessErrorDataAction(),
        ]).pipe(switchMap((d) => d));
      })
    )
  )
)
);

  constructor(
    private actions: Actions,
    private storePageStore: StorePageStore,
    @Inject(STORE_SERVICE) private service: IStoreService
  ) {}
}
